import { render, staticRenderFns } from "./dialog-approve-fuzongshenpi.vue?vue&type=template&id=2553d26e&scoped=true&"
import script from "./dialog-approve-fuzongshenpi.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-fuzongshenpi.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-fuzongshenpi.vue?vue&type=style&index=0&id=2553d26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553d26e",
  null
  
)

export default component.exports